module.exports = __webpack_public_path__ + "static/digital-platform-cube.051717aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital-platform-cube.png
// module id = 696
// module chunks = 103953826085436